import { useState, useRef } from "react"

import { LoginButton, LoginWrapper, LoginFormMain } from "./Atom"
import styles from "../../../styles/Login.module.css"
import { CircularProgress, TextField, Typography } from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { useNavigate } from "react-router"
import OTPContainer from "../../components/OTPContainer"

type VerifyOtpProps = {
  loading: boolean
  email: string
  password?: string
  otp: any
  setOtp: any
  handleSubmit: any
}

const VerifyOtp = (props: VerifyOtpProps) => {
  const { loading, email, password, otp, setOtp, handleSubmit } = props

  const navigate = useNavigate()

  if (!email) {
    navigate("/auth")
  }

  return (
    <LoginWrapper>
      <h4 className={styles.LoginText}>
        Please verify your account by entering the OTP sent to your email
      </h4>
      <LoginFormMain>
        <OTPContainer otp={otp} setOtp={setOtp} handleMethod={handleSubmit} />
      </LoginFormMain>

      <LoginButton
        disabled={otp.length < 6}
        variant="contained"
        onClick={() => handleSubmit()}
        endIcon={
          loading ? (
            <CircularProgress size={20} sx={{ color: "#FFFFFF" }} />
          ) : (
            <ArrowForwardIcon />
          )
        }
      >
        <Typography
          style={{ textTransform: "none" }}
          fontSize={16}
          fontWeight={500}
        >
          Verify Otp
        </Typography>
      </LoginButton>
    </LoginWrapper>
  )
}

export default VerifyOtp
